import { ReactNode } from 'react';
import {
    Body,
    Description,
    DescriptionMedium,
    DescriptionMediumSmall,
    DescriptionSmall,
    DescriptionBold,
} from './text.styles';

export enum TextType {
    body = 'body',
    description = 'descripton',
    descriptionMedium = 'descriptionMedium',
    descriptionMediumSmall = 'descriptionMediumSmall',
    descriptionSmall = 'descriptionSmall',
    descriptionBold = 'descriptionBold',
}

export interface TextProps {
    children: ReactNode;
    type?: TextType;
    color?: string;
    alignment?: 'center' | 'auto' | 'left' | 'right';
    noWrap?: boolean;
    /**
     * Let the text break at any character, so that one long unbroken string (an
     * id, an email address, a URL) can't hold its container wider than the
     * screen. Leave it off for prose: squeezed, it breaks ordinary words too.
     */
    breakAnywhere?: boolean;
}

export function Text({
    children,
    type,
    color,
    alignment,
    noWrap = false,
    breakAnywhere = false,
}: TextProps) {
    let ComponentType: any = Body;
    switch (type) {
        case TextType.descriptionMedium:
            ComponentType = DescriptionMedium;
            break;
        case TextType.descriptionBold:
            ComponentType = DescriptionBold;
            break;
        case TextType.descriptionSmall:
            ComponentType = DescriptionSmall;
            break;
        case TextType.descriptionMediumSmall:
            ComponentType = DescriptionMediumSmall;
            break;
        case TextType.description:
            ComponentType = Description;
            break;
        case TextType.body:
        default:
            ComponentType = Body;
            break;
    }

    return (
        <ComponentType
            color={color}
            $alignment={alignment}
            $noWrap={noWrap}
            $breakAnywhere={breakAnywhere}
        >
            {children}
        </ComponentType>
    );
}
